import { render, staticRenderFns } from "./NordSearchPage.vue?vue&type=template&id=044b5b89&"
import script from "./NordSearchPage.vue?vue&type=script&lang=js&"
export * from "./NordSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044b5b89')) {
      api.createRecord('044b5b89', component.options)
    } else {
      api.reload('044b5b89', component.options)
    }
    module.hot.accept("./NordSearchPage.vue?vue&type=template&id=044b5b89&", function () {
      api.rerender('044b5b89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/NordSearchPage.vue"
export default component.exports